// @ts-check
import styled from 'styled-components';
import Tooltip from '@material-ui/core/Tooltip';
import _ from 'lodash';

import { Flex } from 'components/base/layout-components';
import { TRACKING } from 'common/constants/constants';
import * as TrackingService from 'common/services/tracking.service';
import Icon from 'components/base/Icon';
import Text from 'components/base/Text';
import { LBButton } from '@linearb/buzz';

const IconWrapper = styled(Icon)`
  position: absolute;
  right: -0.5rem;
  top: -0.5rem;
`;

const AccuracyBox = ({
  statusIconName,
  targetIconColor,
  percent,
  content,
  contentColor,
  AccuracyType,
  tooltipContent,
  description
}) => {
  return (
    <Flex pr='large' pt='x-small' pb='x-small'>
      <Flex position='relative' ml='x-small' mr='small' mt='small'>
        <Icon
          data-testid='status-icon'
          name='target'
          size='large'
          color={targetIconColor}
        />
        <IconWrapper name={statusIconName} size='large' />
      </Flex>
      <Flex direction='column'>
        <Text data-testid='percent' size='x-x-large' color='shuttleGray'>
          {percent}
        </Text>
        <Text
          data-testid='content'
          color={contentColor}
          mb='0.7rem'
          weight='bold'
        >
          {content}
        </Text>
        <Text color='shuttleGray'>{description}</Text>
        <Flex items='center' pt='small'>
          <Text data-testid='accuracy-type' mr='0.3rem' color='shuttleGray'>
            {AccuracyType}
          </Text>
          <Tooltip
            data-testid='project-api-accuracy-box-tooltip'
            title={tooltipContent}
            onOpen={_.once(() => {
              const accuracyTypeTitleCase = _.startCase(
                _.toLower(AccuracyType)
              );
              TrackingService.logEvent(TRACKING.EVENTS.HOVER, {
                page: TRACKING.PAGES.PROJECTS,
                hover_type: accuracyTypeTitleCase
              });
            })}
          >
            <LBButton variant='ghost' size='icon'>
              <Icon color='chambray' name='infoOutlined' size='smaller' />
            </LBButton>
          </Tooltip>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default AccuracyBox;
